'use strict';

module.exports = {
    isAffiliateURL: function () {
        $(window).on('load', function () {
            const params = new URLSearchParams(window.location.search);
            if ($('#marketingAttribution').length > 0) {
                let cid = params.has('cid') ? params.get('cid') : '';
                let affName = params.has('Affname') ? params.get('Affname') : '';
                let utmCampaign = params.has('utm_campaign') ? params.get('utm_campaign') : '';
                let url = $('#marketingAttribution').val();

                if (cid.startsWith('AFF_') || cid.startsWith('SMS') || utmCampaign.startsWith('SMS')) {
                    $.ajax({
                        url: url,
                        type: 'post',
                        dataType: 'json',
                        data: {
                            cid: cid,
                            Affname: affName,
                            utmCampaign: utmCampaign
                        },
                        success: function () {
                            // Do Nothing!!
                        },
                        error: function () {
                            // Do Nothing!!
                        }
                    });
                }
            }
        });
    }
};